module.exports = __webpack_public_path__ + "img/nav_img_03.b69ca34e.jpg";